import { APPOINTMENT_TABLE_HEADERS } from "./appointmentViewShared";

export default function AppointmentTableHead({ sticky = false }: { sticky?: boolean }) {
  return (
    <thead
      className={`bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-700 dark:to-slate-800 border-b-2 border-slate-200 dark:border-slate-600 ${
        sticky ? "sticky top-0 z-10 shadow-sm" : ""
      }`}
    >
      <tr>
        {APPOINTMENT_TABLE_HEADERS.map((col) => (
          <th
            key={col.key}
            className={`px-4 xl:px-6 py-3.5 text-[11px] font-bold text-slate-600 dark:text-slate-200 uppercase tracking-wider ${
              col.align === "center"
                ? "text-center w-28 xl:w-32"
                : "text-left"
            }`}
          >
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );
}
